export const areSearchParamsTheSame = (
  a: URLSearchParams,
  b: URLSearchParams,
) => {
  return a === b || a.toString() === b.toString();
};
